/* ===================================================================
   THE FLOAT CLUB — fc-reviews.js
   Customer review submission.

   Set ENDPOINT to any service that accepts a POST (Formspree, Basin,
   Getform, a Shopify app webhook, your own function). With it empty the
   form still works: it opens a prefilled email so the review actually
   reaches you rather than vanishing into a dead handler.

   Submissions are NOT written onto the page. Published reviews on a
   shop have to be genuine and tied to a real order — auto-publishing
   whatever a form receives is how fake review sections get built, and
   in the UK that is an offence under the DMCC Act 2024. These land in
   your inbox and you put the real ones up.
=================================================================== */
(function (global) {
  "use strict";

  var ENDPOINT = "";                 // e.g. "https://formspree.io/f/xxxxxxx"
  var REVIEW_EMAIL = "";             // fallback inbox, e.g. "hello@thefloatclub.com"

  var form = document.getElementById("fc-review-form");
  if (!form) return;

  var statusEl = document.getElementById("fc-review-status");
  var ratingEl = document.getElementById("fc-rating");
  var stars = Array.prototype.slice.call(document.querySelectorAll("[data-star]"));

  function paintStars(n) {
    stars.forEach(function (b) {
      var on = Number(b.getAttribute("data-star")) <= n;
      b.style.color = on ? "#B8860B" : "rgba(5,34,43,0.78)";
      b.style.borderColor = on ? "rgba(255,197,61,0.55)" : "rgba(5,34,43,0.22)";
      b.style.background = on ? "rgba(255,197,61,0.14)" : "#FFFFFF";
      b.setAttribute("aria-checked", on && Number(b.getAttribute("data-star")) === n ? "true" : "false");
    });
  }

  stars.forEach(function (b) {
    b.addEventListener("click", function () {
      var n = Number(b.getAttribute("data-star"));
      ratingEl.value = String(n);
      paintStars(n);
    });
    b.addEventListener("mouseenter", function () {
      paintStars(Number(b.getAttribute("data-star")));
    });
  });
  form.addEventListener("mouseleave", function () {
    paintStars(Number(ratingEl.value || 0));
  });

  function say(msg, ok) {
    if (!statusEl) return;
    statusEl.textContent = msg;
    statusEl.style.color = ok ? "#7A5200" : "rgba(5,34,43,0.78)";
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    var data = {
      name: form.name.value.trim(),
      email: form.email.value.trim(),
      dog: form.dog.value.trim(),
      rating: ratingEl.value,
      review: form.review.value.trim()
    };

    if (!data.name || !data.email || !data.review) {
      say("Please add your name, email and a few words.", false);
      return;
    }
    if (!data.rating) {
      say("Pick a star rating first.", false);
      return;
    }

    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.style.opacity = "0.6"; }
    say("Sending…", false);

    function done(ok) {
      if (btn) { btn.disabled = false; btn.style.opacity = "1"; }
      if (ok) {
        form.reset();
        ratingEl.value = "";
        paintStars(0);
        say("Thank you. We check every review against a real order before it goes up.", true);
      } else {
        say("That didn't send. Please try again, or email us directly.", false);
      }
    }

    if (ENDPOINT) {
      fetch(ENDPOINT, {
        method: "POST",
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify(data)
      })
        .then(function (r) { done(r.ok); })
        .catch(function () { done(false); });
      return;
    }

    // No endpoint configured: hand it to the mail client so the review is
    // still actually delivered rather than silently dropped.
    var to = REVIEW_EMAIL;
    if (!to) {
      done(false);
      say("Reviews aren't wired to an inbox yet. Set ENDPOINT or REVIEW_EMAIL in assets/fc-reviews.js.", false);
      return;
    }
    var body = "Name: " + data.name +
      "\nEmail: " + data.email +
      "\nDog and size: " + (data.dog || "-") +
      "\nRating: " + data.rating + "/5" +
      "\n\n" + data.review;
    global.location.href = "mailto:" + to +
      "?subject=" + encodeURIComponent("Float Club review from " + data.name) +
      "&body=" + encodeURIComponent(body);
    done(true);
  });

  paintStars(0);

})(window);
